var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6C13 5.44772 13.4477 5 14 5H17C17.5523 5 18 5.44772 18 6C18 6.55228 17.5523 7 17 7H15.2C15.0895 7 15 7.08954 15 7.2V8.8C15 8.91046 15.0895 9 15.2 9H17C17.5523 9 18 9.44772 18 10V13C18 13.2652 17.8946 13.5196 17.7071 13.7071L14.7071 16.7071C14.3166 17.0976 13.6834 17.0976 13.2929 16.7071C12.9024 16.3166 12.9024 15.6834 13.2929 15.2929L15.9414 12.6444C15.9789 12.6069 16 12.556 16 12.5029V11.2C16 11.0895 15.9105 11 15.8 11H14C13.4477 11 13 10.5523 13 10V6Z",
    fill: "#f8f1f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6V13.1029C9 13.2811 8.78457 13.3704 8.65858 13.2444L8.05858 12.6444C8.02107 12.6069 8 12.556 8 12.5029V12C8 11.4477 7.55228 11 7 11C6.44771 11 6 11.4477 6 12V13C6 13.2652 6.10536 13.5196 6.29289 13.7071L9.29289 16.7071C9.57889 16.9931 10.009 17.0787 10.3827 16.9239C10.7564 16.7691 11 16.4045 11 16V6Z",
    fill: "#f8f1f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33617 4.42426C1.07798 2.61696 2.48037 1 4.30602 1H19.694C21.5196 1 22.922 2.61696 22.6638 4.42426L21.0948 15.4074C20.9933 16.1178 20.6405 16.7683 20.1005 17.2409L13.9755 22.6002C12.8444 23.5899 11.1556 23.5899 10.0245 22.6002L3.89952 17.2409C3.35945 16.7683 3.00667 16.1178 2.90519 15.4074L1.33617 4.42426ZM4.30602 3C3.69747 3 3.23001 3.53899 3.31607 4.14142L4.88509 15.1245C4.91892 15.3613 5.03651 15.5782 5.21653 15.7357L11.3415 21.095C11.7185 21.4249 12.2815 21.4249 12.6585 21.095L18.7835 15.7357C18.9635 15.5782 19.0811 15.3613 19.1149 15.1245L20.6839 4.14142C20.77 3.53899 20.3025 3 19.694 3H4.30602Z",
    fill: "#f8f1f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.dbff0b8e9f267ef85506fd3fc41f9e5a.svg";
export { ForwardRef as ReactComponent };